import script from "./WithdrawalsScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./WithdrawalsScreen.vue?vue&type=script&setup=true&lang=js"

import "./WithdrawalsScreen.vue?vue&type=style&index=0&id=423fbc8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423fbc8a"]])

export default __exports__